import React from "react";
import { Col, Container, Button, Row, Form } from "react-bootstrap";
import "./Footer.css";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const handleLinkedinClick = () => {
    window.open("https://www.linkedin.com/in/tanvir-ahmed055");
  };

  const handleGithubClick = () => {
    window.open("https://github.com/tanvirahmed055");
  };

  const handleStackoverflowClick = () => {
    window.open("");
  };

  return (
    <div
      className="  text-white"
      style={{ backgroundColor: "RGB(51, 51, 51)", maxWidth: "100vw" }}
    >
      <Container className="pt-4">
        <Row>
          <Col sm={4} className="mx-auto">
            <div className="icons text-center mb-2 pt-5">
              <i
                className="fa fa-linkedin fa-inverse fa-2x me-4"
                onClick={handleLinkedinClick}
                style={{ cursor: "pointer" }}
              ></i>
              <i
                className="fa fa-github fa-inverse fa-2x me-4"
                onClick={handleGithubClick}
                style={{ cursor: "pointer" }}
              ></i>
              <i
                className="fa fa-stack-overflow fa-2x fa-inverse me-4"
                onClick={handleGithubClick}
                style={{ cursor: "pointer" }}
              ></i>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex flex-column align-self-end justify-content-center pb-5  fw-light">
            <hr />
            <p className="text-white">
              Copyright © {new Date().getFullYear()} - Website developed by
              Tanvir Ahmed
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
